import React, { useEffect, useState, useRef } from 'react'
import styles from './index.module.scss'
import Mint from '../../assets/img/mint.png'
import { getOrderStatus } from '../../api/orders'
import QRCode from 'react-qr-code'

const PAYMENT_STATUS = {
    CREATED: 'CREATED',
    PAID: 'PAID',
    CANCELLED: 'CANCELLED',
    EXPIRED: 'EXPIRED'
};

const Index = ({
    request,
    getUniqueArray,
    handleSubmitRequest,
    setSteps,
    steps,
    orderId,
    count = [],
    totalPrice = 0,
    paymentData,
    setPaymentData,
    paymentMode, // 'qr' | 'waiter'
    onBack,
    isQrMode = false,
    onPaymentSuccess
}) => {
    const [paymentStatus, setPaymentStatus] = useState(paymentData?.status || PAYMENT_STATUS.CREATED);
    const [isPaid, setIsPaid] = useState(false);
    const [loading, setLoading] = useState(false);
    const pollingRef = useRef(null);
    const autoCloseRef = useRef(null);
    const handleSubmitRequestRef = useRef(handleSubmitRequest);
    handleSubmitRequestRef.current = handleSubmitRequest;
    const onPaymentSuccessRef = useRef(onPaymentSuccess);
    onPaymentSuccessRef.current = onPaymentSuccess;

    useEffect(() => {
        if (paymentMode !== 'waiter') return;
        autoCloseRef.current = setTimeout(() => {
            handleSubmitRequestRef.current('ok');
        }, 15000);
        return () => clearTimeout(autoCloseRef.current);
    }, [paymentMode]);

    useEffect(() => {
        if (!isPaid && paymentStatus !== PAYMENT_STATUS.PAID) return;
        autoCloseRef.current = setTimeout(() => {
            handleSubmitRequestRef.current('ok');
        }, 15000);
        return () => clearTimeout(autoCloseRef.current);
    }, [isPaid, paymentStatus]);

    // Поллинг статуса оплаты
    useEffect(() => {
        if (!paymentData?.paymentOrderId) return;

        const checkStatus = async () => {
            try {
                const statusData = await getOrderStatus(paymentData.paymentOrderId);
                setPaymentStatus(statusData.status);

                if (statusData.status === PAYMENT_STATUS.PAID) {
                    setIsPaid(true);
                    clearInterval(pollingRef.current);
                    setPaymentData(prev => ({ ...prev, status: PAYMENT_STATUS.PAID }));
                    if (onPaymentSuccessRef.current) onPaymentSuccessRef.current();
                } else if (statusData.status === PAYMENT_STATUS.CANCELLED || statusData.status === PAYMENT_STATUS.EXPIRED) {
                    clearInterval(pollingRef.current);
                }
            } catch (error) {
                console.error('Ошибка проверки статуса:', error);
            }
        };

        // Проверяем статус каждые 3 секунды
        pollingRef.current = setInterval(checkStatus, 3000);
        checkStatus(); // Первая проверка сразу

        return () => {
            if (pollingRef.current) {
                clearInterval(pollingRef.current);
            }
        };
    }, [paymentData?.paymentOrderId, setPaymentData]);

    const renderPaymentSection = () => {
        // Режим оплаты официанту
        if (paymentMode === 'waiter') {
            return (
                <div className={styles.off}>К Вам подойдёт официант</div>
            );
        }

        // Режим оплаты по QR
        if (paymentMode === 'qr') {
            if (isPaid || paymentStatus === PAYMENT_STATUS.PAID) {
                return (
                    <div className={styles.paymentSuccess}>
                        <div className={styles.successIcon}>✓</div>
                        <div className={styles.successText}>Оплата прошла успешно!</div>
                    </div>
                );
            }

            if (paymentData?.qrUrl) {
                return (
                    <div className={styles.qrSection}>
                        <div className={styles.qrTitle}>Отсканируйте QR-код для оплаты</div>
                        <div className={styles.qrWrapper}>
                            <QRCode
                                value={paymentData.qrUrl}
                                size={200}
                                level="H"
                                bgColor="#ffffff"
                                fgColor="#000000"
                            />
                        </div>
                        <div className={styles.qrStatus}>
                            {paymentStatus === PAYMENT_STATUS.CREATED && 'Ожидание оплаты...'}
                            {paymentStatus === PAYMENT_STATUS.CANCELLED && 'Заказ отменён'}
                            {paymentStatus === PAYMENT_STATUS.EXPIRED && 'Время оплаты истекло'}
                        </div>
                    </div>
                );
            }
        }

        return null;
    };

    return (
        <div className={styles.request_bg}>
            <div className={styles.request_popup}>
                <div>
                    <div className={styles.requestTitle}>
                        {isPaid ? 'Оплачено!' : 'Спасибо!'} Ваш заказ № {orderId}
                    </div>
                    {/* <div className={styles.requestTitle}>Ваш заказ № {orderId}</div> */}
                </div>

                <div className={styles.contentRow}>
                    {renderPaymentSection()}

                    <div className={styles.requestList}>
                        {getUniqueArray(request).map((item, index) => {
                            return (
                                <div key={index} className={styles.requestItem}>
                                    {item.title_ru}
                                    - {request
                                        .filter(item_ => item_.id === item.id)
                                        .length}
                                </div>
                            )
                        })}
                    </div>
                </div>
                        <div className={styles.price}>Итого: {totalPrice} руб.</div>

                <div className={styles.endText}>
                    {isQrMode && !isPaid && paymentStatus !== PAYMENT_STATUS.PAID && (
                        <div
                            className={`${styles.cancel} ${loading ? styles.disabled : ''}`}
                            onClick={async () => {
                                if (loading) return;
                                setLoading(true);
                                try {
                                    await handleSubmitRequest('cancel');
                                } finally {
                                    setLoading(false);
                                }
                            }}
                        >
                            {loading ? 'загрузка...' : 'отменить заказ'}
                        </div>
                    )}

                    {isQrMode && !isPaid && paymentStatus !== PAYMENT_STATUS.PAID && (
                        <div
                            className={`${styles.back} ${loading ? styles.disabled : ''}`}
                            onClick={async () => {
                                if (loading) return;
                                setLoading(true);
                                try {
                                    await onBack();
                                } finally {
                                    setLoading(false);
                                }
                            }}
                        >
                            {loading ? 'загрузка...' : 'вернуться'}
                        </div>
                    )}

                    {(paymentMode === 'waiter' || isPaid || paymentStatus === PAYMENT_STATUS.PAID) && (
                        <div
                            className={`${styles.ok} ${loading ? styles.disabled : ''}`}
                            onClick={async () => {
                                if (loading) return;
                                setLoading(true);
                                try {
                                    await handleSubmitRequest('ok');
                                } finally {
                                    setLoading(false);
                                }
                            }}
                        >
                            <img src={Mint} className={styles.mint} alt='Mint'/>
                            {isPaid ? 'Готово' : 'ОК'}
                        </div>
                    )}
                </div>
            </div>
        </div>
    )
}

export default Index
